import React from 'react'

const EditFestival = () => {
  return (
    <div>EditFestival</div>
  )
}

export default EditFestival